/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { propertyComplementaryTypeCodeSchema } from "./propertyComplementaryTypeCodeSchema.ts";
import { z } from "zod";

export const propertyComplementarySchema = z.object({
      "complements": z.array(z.lazy(() => propertyComplementaryTypeCodeSchema).describe("Équipement complémentaire du bien — libellés et compatibilité avec la nature dans form-rules/property-form.json (champ complements)")).optional(),
  "garageNumber": z.number().describe("Nombre de garages").optional(),
  "parkingNumber": z.number().describe("Nombre de parkings").optional(),
  "levelNumber": z.number().describe("Nombre d'étages").optional(),
  "level": z.number().describe("Etage").optional()
      })